const STORAGE_KEY = "lastGenerateParams";
export const DEFAULT_GENERATE_PARAMS = {
  same_show_segues: true,
};

export function getStoredGenerateParams() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    console.error("Failed to read generation params:", err);
    return null;
  }
}

export function setStoredGenerateParams(params = {}) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(params || {}));
  } catch (err) {
    console.error("Failed to persist generation params:", err);
  }
}

export function buildGenerateQueryString(params = {}) {
  const search = new URLSearchParams();

  if (params.era) {
    search.set("era", params.era);
  }

  if (params.jamminess !== undefined) {
    search.set("jamminess", String(params.jamminess));
  }

  if (params.same_show_segues !== undefined) {
    search.set("same_show_segues", params.same_show_segues ? "true" : "false");
  }

  return search.toString();
}

export function normalizeGenerateParams(raw = {}) {
  const normalized = {};

  if (raw.era) {
    normalized.era = raw.era;
  }

  if (raw.jamminess !== undefined && raw.jamminess !== null) {
    const jamValue = Number(raw.jamminess);
    if (!Number.isNaN(jamValue)) {
      normalized.jamminess = Number(jamValue.toFixed(2));
    }
  }

  if (raw.same_show_segues !== undefined) {
    normalized.same_show_segues = Boolean(raw.same_show_segues);
  }

  return normalized;
}
